'use strict';

angular.module('programme', [
    'ui.router',
    "com.2fdevs.videogular",
    "com.2fdevs.videogular.plugins.controls",
    "com.2fdevs.videogular.plugins.poster"
])

.factory('currentArticleState', function()
{
    return {
        'article': null,
        'currentPage': null,
    };
});
